// Imported from the leaf module rather than the package index, which would pull the backend pay-gate
// into the bundle. Shared with the runs-usage email, which names the same reset date.
export { getMonthlyRunsResetDate } from '@env0/common-pay-gate/src/monthly-runs-reset';

export const MONTHLY_RUNS_PAY_GATE_MARKER = 'Monthly Runs';

export const isMonthlyRunsPayGateError = (errorText: string | null): boolean =>
  !!errorText && errorText.includes(MONTHLY_RUNS_PAY_GATE_MARKER);
